import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResourcesView from '../views/ResourcesView.vue'
import AboutView from '../views/AboutView.vue'
import GalleryView from '../views/GalleryView.vue'
import BlogView from '../views/BlogView.vue'
import BlogPostView from '../views/BlogPostView.vue'
import ProductView from '../views/ProductView.vue'
import ProfileView from '../views/ProfileView.vue'
import AccountView from '../views/AccountView.vue'
import CheckoutView from '../views/CheckoutView.vue'
import ServicesView from '../views/ServicesView.vue'
import NotFoundView from '../views/NotFoundView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: "Ben Chiboub Home",
    },
  },
  {
    path: '/resources',
    name: 'resources',
    component: ResourcesView,
    meta: {
      title: "Ben Chiboub resources",
    },
  },
  {
    path: '/blog/:page',
    name: 'blogView',
    component: BlogView,
    props: {
      default: true
    },
    meta: {
      title: "Ben Chiboub Blog",
    },
  },
  {
    path: '/post/:id',
    name: 'blogPostView',
    component: BlogPostView,
    props: {
      default: true
    },
    meta: {
      title: "Ben Chiboub Blog",
    },
  },
  {
    path: '/gallery',
    name: 'galleryView',
    component: GalleryView,
    meta: {
      title: "Ben Chiboub Gallery",
    },
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      title: "about Hédi",
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFoundView,
    meta: {
      title: "Page Not Found",
    },
  },

 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    window.scrollTo(0, 0);
  }
})

router.beforeEach((to) => {
  const { title } = to.meta;
  const defaultTitle = 'Hédi Ben Chiboub';
  document.title = title || defaultTitle
})

export default router
